import { PageLanguageVersion } from '../gatsby/utils'

export type Translations = Record<string, string | null | undefined>

export type TranslationMap = Record<string, Translations>

export interface GetCurrentPageLanguageVersionsOptions {
  homePageLanguageVersions: PageLanguageVersion[]
  languageVersions: PageLanguageVersion[]
}

export const getTranslations = (
  language: string,
  translationMap?: TranslationMap
): Translations => translationMap?.[language] ?? {}

export const getCurrentPageLanguageVersions = ({
  homePageLanguageVersions,
  languageVersions,
}: GetCurrentPageLanguageVersionsOptions) =>
  homePageLanguageVersions.map(homePageLanguageVersion => {
    const currentPageLanguageVersion = languageVersions.find(
      languageVersion => languageVersion.language === homePageLanguageVersion.language
    )

    if (currentPageLanguageVersion) {
      return currentPageLanguageVersion
    } else {
      return {
        language: homePageLanguageVersion.language ?? '',
        path: homePageLanguageVersion.path ?? '',
      }
    }
  }) ?? []
